import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Controller } from "react-hook-form";
import { useTheme } from "@mui/material/styles";
import {
  GREY_COLOR,
  INPUT_COLOR_BORDER,
  WHITE_DARK_COLOR,
} from "../../../utils/colors";
import FieldBlock from "./FieldBlock";
import FieldError from "./FieldError";
import { getVisibleFieldErrorMessage } from "../preActivationVisibleErrors";

const CheckboxField = ({ name, label, control, readOnly, required }) => {
  const theme = useTheme();
  const interactive = !readOnly;

  return (
    <FieldBlock>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState, formState }) => (
          <>
            <Box
              component="label"
              htmlFor={name}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1.25,
                p: 1.5,
                borderRadius: "9px",
                backgroundColor: WHITE_DARK_COLOR,
                border: `1px solid ${INPUT_COLOR_BORDER}`,
                cursor: interactive ? "pointer" : "default",
                opacity: interactive ? 1 : 0.92,
                ...(interactive && {
                  "&:hover": {
                    backgroundColor: GREY_COLOR,
                    borderColor: theme.palette.primary.main,
                  },
                }),
              }}
            >
              <Box
                component="input"
                type="checkbox"
                id={name}
                name={name}
                checked={Boolean(field.value)}
                disabled={!interactive}
                onChange={(event) => field.onChange(event.target.checked)}
                sx={{
                  width: 16,
                  height: 16,
                  accentColor: theme.palette.primary.main,
                  cursor: "inherit",
                  flexShrink: 0,
                  marginTop: "2px",
                }}
              />
              <Typography
                sx={{
                  color: "text.primary",
                  fontSize: "14px",
                  lineHeight: 1.4,
                  cursor: "inherit",
                }}
              >
                {label}
                {required ? " *" : ""}
              </Typography>
            </Box>
            <FieldError message={getVisibleFieldErrorMessage(fieldState, formState)} />
          </>
        )}
      />
    </FieldBlock>
  );
};

export default CheckboxField;
